import { render } from "./StudentOnHold.vue?vue&type=template&id=511ce5d2"
import script from "./StudentOnHold.vue?vue&type=script&lang=js"
export * from "./StudentOnHold.vue?vue&type=script&lang=js"
script.render = render

export default script